import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async checkout(event) {
    const button = event.currentTarget
    const paymentType = button.dataset.paymentType || "subscription"
    const originalText = button.textContent

    button.disabled = true
    button.textContent = "Processing..."

    try {
      // Get customer_permalink from URL params
      const urlParams = new URLSearchParams(window.location.search)
      const customerPermalink = urlParams.get('customer_permalink')

      const params = new URLSearchParams({
        payment_type: paymentType
      })

      if (customerPermalink) params.append('customer_permalink', customerPermalink)

      const response = await fetch('/subscription/create_checkout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: params
      })

      const data = await response.json()

      if (response.ok && data.checkout_url) {
        window.location.href = data.checkout_url
      } else if (data.redirect_url) {
        // Redirect to settings page if business info is missing
        window.location.href = data.redirect_url
      } else {
        alert(data.error || 'An error occurred. Please try again.')
        button.disabled = false
        button.textContent = originalText
      }
    } catch (error) {
      console.error('Checkout error:', error)
      alert('An error occurred. Please try again.')
      button.disabled = false
      button.textContent = originalText
    }
  }
}
